import React from 'react';
import { HeaderHeights, Header, MainWrapperForNavigation, ThreeRowsHeader, Drawer, GoogleOAuth, MicrosoftOAuth } from 'mm-ui-components';
import { MainWrapperConfigThemeKey } from 'mm-ui-components/dist/src/base/wrappers/mainWrapper/mainWrapper.theme';
import { useSelector } from 'react-redux';
import { FooterConnected } from './FooterConnected';
import { getHeader, getLatestArticles, getSecondaryLogo, getSubHeader } from '../../store/navigations/navigation/header/header.selectors';
import { getMenu } from '../../store/navigations/navigation/menu/menu.selectors';
import { getEditionEndpoint, getPagePath, getPropertyEndpoint, getIsFannation, getSiteName, getExperiments, getIsMobileViewer, getEdition } from '../../store/config/config.selectors';
import { isPropertyForThreeRowsHeader, isSiProperty } from '../../store/config/config.utils';
import { hasOAuth } from '../../utilities/hasOAuth';

interface NavigationLayoutProps {
  mainWrapperConfigThemeKey: MainWrapperConfigThemeKey;
  isFullBleed?: boolean;
  noMarginTop?: boolean;
}

const HeaderConnected: React.FunctionComponent = () => {
  const header = useSelector(getHeader);
  const menu = useSelector(getMenu);
  const pagePath = useSelector(getPagePath);
  const siteName = useSelector(getSiteName);
  const editionEndpoint = useSelector(getEditionEndpoint);
  const propertyEndpoint = useSelector(getPropertyEndpoint);
  const isFannation = useSelector(getIsFannation);
  const connectedComponent = isSiProperty(propertyEndpoint) || isPropertyForThreeRowsHeader(propertyEndpoint)
  ? <ThreeRowsHeader {...header} menu={menu} propertyEndpoint={propertyEndpoint} siteName={siteName} editionEndpoint={editionEndpoint} isFannation={isFannation} />
  : <Header {...header} menu={menu} pagePath={pagePath} editionEndpoint={editionEndpoint} />;
  return connectedComponent;
};

export const NavigationLayout: React.FunctionComponent<NavigationLayoutProps> = props => {
  const secondaryLogo = useSelector(getSecondaryLogo);
  const latestArticles = useSelector(getLatestArticles);
  const experiments = useSelector(getExperiments);
  const propertyEndpoint = useSelector(getPropertyEndpoint);
  const editionEndpoint = useSelector(getEditionEndpoint);
  const edition = useSelector(getEdition);
  const isMobileViewer = useSelector(getIsMobileViewer);
  const urlEndpoint = editionEndpoint || propertyEndpoint || '';
  const isFannation = useSelector(getIsFannation);
  const hasGoogleAuth = hasOAuth('google-oauth', urlEndpoint, experiments, edition, isFannation);
  const hasMicrosoftOAuth = hasOAuth('microsoft-oauth', urlEndpoint, experiments, edition, isFannation);
  const { children, mainWrapperConfigThemeKey, isFullBleed, noMarginTop = false } = props;
  const doesSubHeaderExist = !!useSelector(getSubHeader) && !secondaryLogo;

  return (
    <HeaderHeights doesSubHeaderExist={doesSubHeaderExist}>
      {hasGoogleAuth && <GoogleOAuth propertyUrl={propertyEndpoint || editionEndpoint} isMobile={isMobileViewer} />}
      {hasMicrosoftOAuth && <MicrosoftOAuth propertyUrl={propertyEndpoint || editionEndpoint} />}
      <HeaderConnected />
      {latestArticles && <Drawer articles={latestArticles} />}
      <MainWrapperForNavigation configThemeKey={mainWrapperConfigThemeKey} isFullBleed={isFullBleed} noMarginTop={noMarginTop}>
        {children}
      </MainWrapperForNavigation>
      <FooterConnected />
    </HeaderHeights>
  );
};
